import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        localStorage.setItem("token", data.token);
        // Clear the hash and hard-navigate so AuthContext re-initialises from the token
        window.history.replaceState(null, "", "/");
        window.location.href = "/";
      } catch (e) {
        toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Accesso Google non riuscito");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-navy">
      <img src="/logo.png" alt="logo" className="h-20 w-20 animate-pulse rounded-xl" />
      <p className="text-gold">Accesso in corso…</p>
    </div>
  );
}
